import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcTrain(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.25 15.367a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.402 2.25a2.75 2.75 0 0 0-2.7 2.23L3.7 14.885a3.75 3.75 0 0 0 2.867 4.37L4.72 21.104a.75.75 0 1 0 1.06 1.06l.593-.593h11.254l.593.593a.75.75 0 1 0 1.06-1.06l-1.847-1.848a3.75 3.75 0 0 0 2.867-4.37L18.3 4.48a2.75 2.75 0 0 0-2.701-2.23zm.068 17.094a.75.75 0 0 1-.19.32l-.407.406h8.254l-.407-.407a.75.75 0 0 1-.19-.32zM7.174 4.764A1.25 1.25 0 0 1 8.402 3.75H15l-7.5 7.5H5.926zM5.638 12.75l-.465 2.419a2.25 2.25 0 0 0 2.209 2.675h9.236a2.25 2.25 0 0 0 2.21-2.675l-.466-2.419zm12.435-1.5-1.247-6.486a1.25 1.25 0 0 0-.218-.5L9.62 11.25z",
    clipRule: "evenodd"
  }));
}
var IcTrain = createNolIcon(/*#__PURE__*/forwardRef(SvgIcTrain));

export { IcTrain as I };
